import { createComponent } from '@carvana/merch-components';
import {
  CommonHeading,
  CommonSection,
  ContentContainer
} from '~/components/flp/Financing.styles';

export const UnlockRealPaymentsSection = createComponent(CommonSection, {
  className: 'bg-canvas-muted sm:py-7xl md:px-4xl'
});

export const Container = createComponent(ContentContainer, {
  className:
    'md:column-gap-7xl grid max-w-[unset] grid-cols-1 gap-3xl md:grid-cols-2 md:gap-4xl'
});

export const Heading = createComponent(CommonHeading, {
  className: 'md:col-start-2'
});

export const Slider = createComponent('div', {
  className: 'col-start-1'
});

export const Content = createComponent('div', {
  className: 'flex flex-col items-center gap-3xl md:col-start-2 md:items-start'
});

export const Step = createComponent('div', {
  className: 'flex gap-2xl'
});

export const StepIndicator = createComponent('div', {
  className: 'relative'
});

export const StepBorder = createComponent('div', {
  className:
    'absolute bottom-0 left-1/2 top-0 -translate-x-1/2 border border-solid border-border-primary'
});

export const StepNumber = createComponent('div', {
  className:
    'relative flex h-[56px] w-[56px] flex-col justify-center rounded-full border-2 border-solid border-border-primary bg-background-default text-center text-text-primary t-heading-xl'
});

export const Body = createComponent('div', {
  className: 'flex flex-col gap-lg py-xl pb-2xl'
});

export const Title = createComponent('h3', {
  className: 'text-text-strong t-heading-lg'
});

export const Description = createComponent('p', {
  className: 'text-text-default t-body-sm'
});
